<script context="module">
    let maxZ = 31;
    let currentZ = 31;
</script>

<script>
    import {onMount, tick} from 'svelte';
    import {draggable} from "../Utilities/Draggable.svelte";
    import {debounce} from "../Utilities/debounce";

    export let id;
    export let visible = true;
    export let component = null;
    export let data = null;
    export let title;

    export let notify = false;

    export let width = 800;
    export let closable = true;

    let zIndex = maxZ++;

    let collapsed;

    let cardContent;

    async function handleWindowResize() {
        if (!cardContent) return

        // wait for component to update
        await tick();

        if (cardContent.clientWidth > window.innerWidth) {
            cardContent.style.width = window.innerWidth + 'px';
        }

        // -44 for the height of the header
        if (cardContent.clientHeight > window.innerHeight - 44) {
            cardContent.style.height = window.innerHeight - 44 + 'px';
        }

    }

    let saveSize = debounce((elem) => {
        if (elem && elem.clientHeight == 0 ||  elem.clientWidth == 0) {
            return
        }

        window.localStorage.setItem(`popup_size_${id}`, JSON.stringify({
            height: elem.clientHeight,
            width: elem.clientWidth
        }))
    }, 500)

    const ro = new ResizeObserver(entries => {
        saveSize(cardContent);
    });

    onMount(() => {
        // see if our dimensions are saved
        if (id) {
            let savedSize = window.localStorage.getItem(`popup_size_${id}`);
            if (savedSize) {
                savedSize = JSON.parse(savedSize);
                cardContent.style.width = savedSize.width + 'px';
                cardContent.style.height = savedSize.height + 'px';
            }
        }
        ro.observe(cardContent);

        window.addEventListener("resize", handleWindowResize)

        return () => {
            ro.disconnect()
            window.removeEventListener("resize", handleWindowResize)
        }
    })

    $: handleWindowResize(visible)

    $: widthpx = width == "auto" ? "auto" : width +"px";
</script>

<div
    class="popup card"
    class:hidden = {!visible}
    class:notify = {notify}
    style="position: fixed; top: 300px; left: 200px; z-index: {zIndex}"
    on:click={() => zIndex = ++currentZ}
    use:draggable={id}>
    <header class="card-header drag-handle">
        <p class="card-header-title is-capitalized">
            <i class="icon collapse-icon" on:click|preventDefault={() => collapsed = !collapsed}>
                {#if collapsed}
                    ▶
                {:else}
                    ▼
                {/if}
            </i>
            {title}
        </p>
        {#if closable}
        <span class="card-header-icon">
            <i class="icon" on:click={() => visible = false}>
                <button class="delete" aria-label="delete"></button>
            </i>
        </span>
        {/if}
    </header>
    <div class="card-content" style="width: {widthpx}" class:hidden={collapsed} bind:this="{cardContent}">
        {#if component}
          <svelte:component this={component} {...data} />
        {:else}
            <slot />
        {/if}
    </div>
</div>

<style>
    .card-content {
        overflow: hidden;
        resize: both;
        padding: 0;
    }

    .drag-handle {
        cursor: grab;
        user-select: none;
    }

    .popup {
        z-index: 5;
    }

    .collapse-icon {
        cursor: pointer;
        font-style: normal;
    }

    .notify .card-header {
        color: white;
        background-color:hsl(171, 100%, 41%);
    }
</style>